import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-11 w-11" }) => (
  <span className={`${className} shrink-0 rounded-sm bg-[#2F2A28] grid place-items-center`} aria-hidden>
    <img src="/brand/helium-mark.svg" alt="" className="h-[72%] w-[72%] object-contain" />
  </span>
);

export const Logo = ({ testId = "header-logo-link" }) => (
  <Link to="/" className="flex items-center gap-3 group" data-testid={testId}>
    <LogoMark />
    <span className="leading-none">
      <span className="block text-white text-[15px] tracking-[0.38em] font-light">HÉLIUM</span>
      <span className="block text-white/60 text-[10px] tracking-[0.32em] mt-1">RÉSIDENCES</span>
    </span>
  </Link>
);
